module.exports = __webpack_public_path__ + "media/images/front/icon_05_arrow2_y-395856e96e139561d07ce5a604d5f85d.png";